/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Filter_AllInputs */



/**
* | output |
* | --- |
* | "All" |
*
* @param {Community_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_filter_all = /** @type {((inputs?: Community_Filter_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Filter_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti")
	return /** @type {LocalizedString} */ ("All")
});